import type * as React from "react";
import {
  useIsLoggedIn,
  usePostponeLogout,
  useWillBeLoggedOut,
} from "@/shared/queries/loggedInStatus.ts";
import { Timeout as ViewsSharedTimeout } from "@/shared/ui/legacy/Timeout.tsx";

const TimeoutWatcherComponent: React.FC = () => {
  const willBeLoggedOut = useWillBeLoggedOut();
  const postponeLogout = usePostponeLogout();

  if (!willBeLoggedOut) {
    return null;
  }

  return (
    <div id="timeout_modals">
      <ViewsSharedTimeout continue_callback={postponeLogout.mutate} />
    </div>
  );
};

export const TimeoutWatcher: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();

  if (!isLoggedIn) {
    return null;
  }

  return <TimeoutWatcherComponent />;
};
